(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-newsletter"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const klaviyoForms = document.querySelectorAll('.klaviyo-form');
  const popup = document.querySelector('.klaviyo-popup');
  const closePopup = document.querySelector('.klaviyo-popup-close');
  const closeButton = document.querySelector('.klaviyo-popup-button');
  const errorContainer = document.querySelector('.klaviyo-error-container');

  // Close popup when clicking the X or the Close button
  if (closePopup) {
    closePopup.addEventListener('click', function() {
      if (popup) popup.style.display = 'none';
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function() {
      if (popup) popup.style.display = 'none';
    });
  }

  // Close popup when clicking outside the content
  if (popup) {
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        popup.style.display = 'none';
      }
    });
  }

  klaviyoForms.forEach(form => {
    let isSubmitting = false; // Prevent multiple rapid submissions

    const emailInput = form.querySelector('input[name="email"]');
    const submitButton = form.querySelector('button[type="submit"]');

    // Clear validation messages when user starts typing
    if (emailInput) {
      emailInput.addEventListener('input', function() {
        this.setCustomValidity('');
      });
    }

    form.addEventListener('submit', function(e) {
      // Prevent default to avoid redirection
      e.preventDefault();

      // Prevent multiple rapid submissions
      if (isSubmitting) {
        return;
      }

      const email = emailInput.value.trim();
      const listId = this.querySelector('input[name="g"]').value;

      // Enhanced email validation regex - supports international characters
      // Allows letters (including international), numbers, dots, hyphens, underscores, and plus signs
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~\u00C0-\u017F-]+@[a-zA-Z0-9\u00C0-\u017F-]+(\.[a-zA-Z0-9\u00C0-\u017F-]+)+$/;

      // Validate email is not empty
      if (!email) {
        emailInput.setCustomValidity('{{ "sections.custom-newsletter.validation_email_empty" | t }}');
        emailInput.reportValidity();
        return;
      }

      // Validate max length (254 is RFC standard)
      if (email.length > 254) {
        emailInput.setCustomValidity('{{ "sections.custom-newsletter.validation_email_length" | t }}');
        emailInput.reportValidity();
        return;
      }

      // Validate email format
      if (!emailRegex.test(email)) {
        emailInput.setCustomValidity('{{ "sections.custom-newsletter.validation_email_format" | t }}');
        emailInput.reportValidity();
        return;
      }

      // Additional validation: check for valid domain structure
      const emailParts = email.split('@');
      if (emailParts.length !== 2 || emailParts[0].length === 0 || emailParts[1].length < 3) {
        emailInput.setCustomValidity('{{ "sections.custom-newsletter.validation_email_format" | t }}');
        emailInput.reportValidity();
        return;
      }

      // Clear any previous validation messages
      emailInput.setCustomValidity('');

      // Mark as submitting and disable button
      isSubmitting = true;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.style.opacity = '0.6';
        submitButton.style.cursor = 'not-allowed';
      }

      // Create a hidden iframe for submission to avoid redirect
      const iframe = document.createElement('iframe');
      iframe.name = 'klaviyo-submit-frame-' + new Date().getTime(); // Unique name each time
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      // Set the form to target the iframe
      form.target = iframe.name;

      // Important: We need to clone the form and use the clone for each submission
      // This ensures that the form is fresh for each submission
      const formClone = form.cloneNode(true);
      formClone.style.display = 'none';
      formClone.target = iframe.name;
      document.body.appendChild(formClone);

      // Set the email in the cloned form
      const emailInputClone = formClone.querySelector('input[name="email"]');
      if (emailInputClone) {
        emailInputClone.value = email;
      }

      // Show success popup ONLY after validation passes
      if (popup) {
        popup.style.display = 'flex';
      }

      fbq('trackCustom', 'NewsletterSignup', {
        content_name: 'Newsletter Signup'
      });

      // Reset the original form
      form.reset();

      // Re-enable submit button after 3 seconds
      setTimeout(() => {
        isSubmitting = false;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.style.opacity = '1';
          submitButton.style.cursor = 'pointer';
        }
      }, 3000);

      // Hide popup after 20 seconds
      setTimeout(() => {
        if (popup) popup.style.display = 'none';
      }, 20000);

      // Submit the cloned form to the iframe
      formClone.submit();

      // Clean up the iframe and cloned form after submission
      setTimeout(() => {
        if (iframe && iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
        if (formClone && formClone.parentNode) {
          formClone.parentNode.removeChild(formClone);
        }
      }, 5000);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
